export enum DocumentType {
    None = 0,
    PrintMail,
    Esi,
    Wausau,
}
